import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import demoIcon from "../assets/arrow-up-right.svg";
import video1 from "../assets/Hero_video_1.mp4";
import video2 from "../assets/Hero_video_2.mp4";
import video3 from "../assets/Hero_video_3.mp4";
import heroPoster from "../assets/heroPoster.jpeg";

export default function Home() {
  const videos = [video1, video2, video3];
  const [currentVideo, setCurrentVideo] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false); // tracks when first video is ready
  const videoRefs = useRef([]);

  useEffect(() => {
    // Preload all videos in background
    videos.forEach((src) => {
      const vid = document.createElement("video");
      vid.src = src;
      vid.preload = "auto";
    });
  }, [videos]);

  const handleVideoEnd = () => {
    const nextIndex = (currentVideo + 1) % videos.length;
    setCurrentVideo(nextIndex);
    if (videoRefs.current[nextIndex]) {
      videoRefs.current[nextIndex].play();
    }
  };

  return (
    <div className="position-relative w-100" id="home" style={{ height: "85vh" }}>
      {/* Poster always mounted — fades out when video ready */}
      <img
        src={heroPoster}
        alt="Hero Poster"
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          objectFit: "cover",
          opacity: isLoaded ? 0 : 1,
          transition: "opacity 1s ease-in-out",
          pointerEvents: "none", // prevent blocking clicks
        }}
      />

      {/* Videos */}
      {videos.map((src, i) => (
        <video
          key={i}
          ref={(el) => (videoRefs.current[i] = el)}
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            objectFit: "cover",
            opacity: i === currentVideo ? 1 : 0,
            transition: "opacity 0.5s ease-in-out",
          }}
          src={src}
          autoPlay={i === 0}
          muted
          playsInline
          onEnded={handleVideoEnd}
          // as soon as first video has data, fade out poster
          onLoadedData={() => {
            if (i === 0) setIsLoaded(true);
          }}
        />
      ))}

      {/* Overlay */}
      <div
        className="d-block d-md-none position-absolute top-0 start-0 w-100 h-100"
        style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
      />
      <div
        className="d-none d-md-block position-absolute top-0 start-0 w-100 h-100"
        style={{
          background: "linear-gradient(to right, rgba(0,0,0,0.9), transparent)",
        }}
      />

      {/* Content */}
      <div className="position-relative text-white h-100 d-flex flex-column justify-content-center sha_new_sep">
        <div>
          <h1 className="display-4 fw-normal mb-3 row col-12 col-lg-7">
            The All-in-One Platform for Sim Performance & Maintenance
          </h1>
          <p className="lead mb-4 py-0 py-md-4 row col-12 col-lg-8">
            Your complete solution for tracking, maintaining, and improving
            simulator performance — trusted by aviation professionals.
          </p>
        </div>
        <div>
<Link to="/request-demo" className="text-decoration-none">
  <button className="btn btn-light btn-lg text-dark fw-semibold d-flex align-items-center gap-2 rounded-pill py-2 py-md-3 px-3 px-md-4">
    <img src={demoIcon} alt="Demo Icon" width={24} height={24} />
    Request a DEMO
  </button>
</Link>

        </div>
      </div>
    </div>
  );
}
